module.exports = __webpack_public_path__ + "img/地图B-移动影像中心.7d87e9f6.png";